 /*	MARK: Ai5 Machine Data models
	============================================
 */
/** Imports **/
import { inject, PLATFORM } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request, AuthRequest,  } from '../services/data-service';
import { Api } from '../services/api';
import { MachineStatus, MachineSignal } from './machine-schemas';
import {EventAggregator} from 'aurelia-event-aggregator';
import { IOEvents } from '../services/io-link';

const TrainingOperation = {
	"linear":"linear",
	"serie":"time_series_train",
	"logist":"logist",
	"multivar_serie":"time_series_multivar_train" };

@inject(DataService, Api, Router, EventAggregator)
export class MachineData {
	/** Components methods **/
	
	constructor(ds,api,router, ea){
		this.ds 	= ds;
		this.router = router;
		this.api	= api;
		this.ea		= ea;
		// Custom vars
		this.new_name = "";
		this.MachineStatus = MachineStatus;
	}

	activate(params){ this.id = params.id }
	
	attached(){
		window.setTimeout( () => { this.init() }, 300);
		// Subscriptions
		this.IOMachineStatusSubs = this.ea.subscribe(IOEvents.MachineStatus, msg => this.onIOMachineStatus(msg));

	}

	detached(){
		this.IOMachineStatusSubs.dispose();
	}


	init(){
		
		let machine = this.ds.app_data.machine;
		if(machine){
			this.machine = machine;
			// Should train machine
			this.shouldTrainMachine(machine);
		}
		else{
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
				// Should train machine
				window.setTimeout( () => {this.shouldTrainMachine(this.machine);}, 600);
				//this.shouldTrainMachine(this.machine);
			})
		}
	}

	/** ============================================
		API remote calls
		============================================
	**/

	requestTrainingQuota(machine){
		// Auth Request
		let subsToken		= this.ds.user.subs;
		let uid				= machine.uid;
		let request			= new AuthRequest("/api/v2/users/"+uid+"/usage-training-token", "POST");

		let body			= { uid:machine.uid };
		request.body		= JSON.stringify(body);
		// Add subs header
		request.headers["Authorization"] = "Bearer " + subsToken; // Bearer + token
		return this.api.post(request);
		
	}

	requestOperToken(oper){
		let subsToken		= this.ds.user.subs;
		let uid				= this.machine.uid;

		let request			= new AuthRequest("/api/v2/users/"+uid+"/oper-token", "POST");
		let body			= { oper:oper, machineId: this.machine._id };
		
		// Add subs header
		request.headers["Authorization"] = "Bearer " + subsToken; // Bearer + token
		return this.api.post(request);
	}
	
	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			this.machine = machine
			this.ds.app_data.machine = machine;
		};
	}

	deleteMachine(machine_id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "DELETE");
		let params  	= new URLSearchParams({ id:machine_id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.remove(request);
	}

	handleDeleteMachineResponse(response){
		// console.log("delete response => ", response);
	}

	updateMachine(machine, fields){
		let request = new Request("/api/v2/machines/", "PUT");
		let body		= { machine: machine, fields:fields };
		request.body	= JSON.stringify(body);
		return this.api.put(request);
	}

	handleResponseUpdateMachine(response){}

	/** Train machine api calls **/
	trainMachineProcess(machine){
		// Machine ID
		let id = machine._id;
		// Create request
		let request 	= new Request("/api/v2/machines/" + id + "/train/", "PUT");
		// Copy machine
		let req_machine = { ... machine };
		req_machine.status = MachineStatus.InTraining;
		let oper		= TrainingOperation[machine.algorithm]
		let body 		= { oper:oper, signal:MachineSignal.Train, machine:req_machine};
		request.body	= JSON.stringify(body);

		// Add headers
		request.headers["Authorization"] = "Bearer " + this.accessToken; // Bearer + token


		// Update local machine list
		// Find by id
		let idx = this.ds.app_data.machines.findIndex(machine => machine._id === this.machine._id)
		if(idx !== -1){
			this.machine.status				= MachineStatus.InTraining
			this.ds.app_data.machines[idx] 	= this.machine;
		}
		
		// Perform api call - Train
		return this.api.put(request);
	}

	handleTrainMachineProcessResponse(response){
		// Parse data from response
		
		//let json_response 	= JSON.parse(response.data)
		let json_response 	= response.data;
		let machine_code 	= json_response.code;

		if(machine_code != 200){ }else{
			this.machine = json_response.data
			// Update ds machine
			this.ds.app_data.machine	= json_response.data;
		}
		//this.machine 		= json_response.data
		window.setTimeout( () => {
			//console.log("??? ", this.machine.status)
		}, 300)
		
	}

	
	stopMachineProcess(machine){
		let	id = machine._id;
		// Create request
		let request 	= new Request("/api/v2/machines/" + id + "/train/", "PUT");
		// Copy machine
		let req_machine = { ... machine };
		let body 		= { oper:"stop", signal:"stop", machine:req_machine};
		request.body	= JSON.stringify(body);

		// Add headers
		request.headers["Authorization"] = "Bearer " + this.accessToken; // Bearer + token
		
		// Perform api call - Train
		return this.api.put(request);
	}
	
	/** Edit machine methods **/

	removeMachine(machine_id){
		this.deleteMachine(machine_id).then(response => {
			this.handleDeleteMachineResponse(response);
			// remove from app data
			this.ds.app_data.machines = this.ds.app_data.machines.filter(machine => machine._id != machine_id);
			// navigate to models
			this.navigateToModels();
		});
	}

	editMachineName(machine, name){
		if(name != ""){
			let fields 			= { "name": name };
			this.machine.name 	= name;  
			this.updateMachine(machine, fields).then(response => {
				this.handleResponseUpdateMachine(response);
			});
		}
	}

	/**	============================================
	   	Action methods
		============================================
	 **/
	shouldTrainMachine_(machine){
		let machine_status = machine.status;
		if(machine_status === MachineStatus.Ready){
			// Procede Training
			// Change machine status
			this.machine.status = MachineStatus.InTraining
			// Train machine |> Remote Server
			this.trainMachineProcess(machine).then(response => {
				// Handle train machine process response
				this.handleTrainMachineProcessResponse(response);
			})
			.finally( () => {});
		}
		else{}
	}

	shouldTrainMachine(machine){
		let machine_status = machine.status;
		if(machine_status === MachineStatus.Ready){
			// Procede Training
			// Change machine status
			this.machine.status = MachineStatus.InTraining;
			// Get Training Token |> Remote Auth Server
			this.requestTrainingQuota(machine).then(authResponse => {
				// Handle auth response 
				if(authResponse.status === 200){ this.accessToken = authResponse.data.oper_token}
				machine.status	= MachineStatus.InTraining;
				return this.trainMachineProcess(machine);
			})
			.then(response => {
				// Handle train machine process response
				this.handleTrainMachineProcessResponse(response);
			})
			.finally( () => {});
		}
		else{}
	}


	stopTraining(){
		this.machine.status		= MachineStatus.Completed;
		let fields				= {"status":MachineStatus.Completed};
		this.updateMachine(this.machine, fields);
		// request oper token
		this.requestOperToken("training").then(response => {
			let status = response.status;

			if(status === 200){
				let data			= response.data;
				this.accessToken	= response.data.oper_token;
				// Send Stop machine signal
				this.stopMachineProcess(this.machine);
			}
		});
	}

	stopTraining_(){
		this.machine.status		= MachineStatus.Completed;
		// Send Stop machine signal
		this.stopMachineProcess(this.machine);
		// Update machine Status Backend
		let fields				= {"status":MachineStatus.Completed};
		this.updateMachine(this.machine, fields);
	}
	
	/** Route training **/
	startTraining(){
		let id = this.machine._id;
		this.router.navigateToRoute('models.dataset', {id: id});
	}

	// Return to models
	navigateToModels(){
		let uid = this.ds.user.uid;
		window.setTimeout( () => {
			this.router.navigateToRoute('models');
		}, 500);
		
	}

	/** ============================================
		IO Events
		============================================
	**/
	onIOMachineStatus(msg){
		let machine_status 	= msg.body.machine_status;
		this.machine.status = machine_status;
		// To Data Service
		this.ds.app_data.machine = this.machine;
		// Get remote machine data
		this.getMachine(this.id).then(response => {
			this.handleMachineResponse(response);

			// Update ds.app_data.machines

			// Find by id
			let idx = this.ds.app_data.machines.findIndex(machine => machine._id === this.machine._id)
			if(idx !== -1){
				this.ds.app_data.machines[idx] = this.machine;
			}
		});
	}
}
